import React from "react";

export interface SectionTitleProps {
  children: React.ReactNode;
  className?: string;
}

export function SectionTitle({ children, className = "" }: SectionTitleProps): React.ReactElement {
  return (
    <div className={`flex flex-col items-center gap-2.5 ${className}`.trim()}>
      <h2 className="text-navy text-3xl font-bold text-center tracking-tight">
        {children}
      </h2>
      <div className="h-0.5 w-16 bg-gold rounded" aria-hidden />
    </div>
  );
}

export default SectionTitle;
